import logoBlaBlaCar from 'assets/images/logos/blablacar-color.svg';
import logoBldr from 'assets/images/logo-menu.svg';
import logoChilidTealspace from 'assets/images/logos/chilid-tealspace.svg';

import { BOX_TYPES } from 'config';

export const industry = [
  'Energy',
  'Media',
  'E-commerce',
  'Travel',
  'SaaS',
  'IT Services',
  'B2B Services',
  'Health & Beauty',
];
export const service = [
  'Full Cycle Product Development',
  'Development Teams',
  'Product Design and Development',
  'Machine Learning',
  'Digital Transformation',
];

export const data = [
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'blablaImage',
      clientLogo: logoBlaBlaCar,
      title:
        'How to deal with rapid growth and the aggressive expansion of a startup.',
      tags: ['php', 'UX/UI', 'scrum'],
      industry: ['Travel'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'white',
      link: '/blog/case-story-blablacar/',
    },
    id: 'box-BlaBlaCar',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'virginImage',
      clientLogo: 'logoVirgin',
      title: 'How to deliver and launch a mobile and web MVP in just 4 weeks.',
      tags: ['ReactJS', 'mobile', 'agile'],
      industry: ['Media'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'mine-shaft',
      textColor: 'white',
      link: '/blog/case-study-virgin-radio-oman/',
    },
    id: 'box-virgin-radio-oman',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '4.5',
      title: 'Tauron Polska Energia',
      industry: ['Energy'],
      service: ['Product Design and Development'],
      subtitle: 'Boldare has shown themselves to be very flexible in the technologies they use.',
      description: 'Krzysztof Osinski, Head of Planning & Development, Tauron Polska energia',
    },
    settings: {
      link: '/reviews/tauron-polska-energia/',
    },
    id: 'box-review-tauron',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'sonnenImage',
      clientLogo: 'logoSonnen',
      title:
        'How to create an app that connects users with the intangible world of solar energy.',
      tags: ['Python', 'MachineLearning', 'MVP', 'Germany'],
      industry: ['Energy'],
      service: ['Machine Learning'],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'rhino',
      textColor: 'white',
      link: '/work/case-study-sonnen/',
    },
    id: 'box-sonnen',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'Eres Yachting',
      industry: ['Travel'],
      service: ['Product Design and Development'],
      subtitle: "The feedback from customers and everyone else we've shown the website to has been that the site is exceptional.",
      description: 'Marketing Manager',
    },
    settings: {
      link: '/reviews/eres-yachting/',
    },
    id: 'box-review-eres',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'polcoImage',
      clientLogo: 'logoPolco',
      title:
        'How Polco.us used the lean approach to deliver a voting platform.',
      tags: ['Information Architecture', 'UI', 'UX', 'HTML5', 'JavaScript'],
      industry: ['SaaS'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'green-dark',
      textColor: 'white',
      link: '/blog/case-study-polco/',
    },
    id: 'box-Polco',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'htwImage',
      clientLogo: 'logoHTW',
      title:
        'How to create predictive maintenance software using machine learning',
      tags: ['machinelearning', 'python', 'ux', 'lean'],
      industry: ['Energy'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Machine Learning',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'white',
      link: '/work/case-study-predictive-maintenance/',
    },
    id: 'box-HTW',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'EZYcount',
      industry: ['SaaS'],
      service: ['Development Teams'],
      subtitle: 'Boldare was able to guide us, and they understood quickly what kind of technical challenges we had – sometimes better than our own people.',
      description: 'Marketing Manager',
    },
    settings: {
      link: '/reviews/ezycount/',
    },
    id: 'box-review-ezycount',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'tojarImage',
      clientLogo: 'logo910',
      title: 'How to deliver an e-commerce platform MVP in just 6 weeks.',
      tags: ['php', 'symfony', 'agile', 'mvp'],
      industry: ['E-commerce'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'mine-shaft',
      textColor: 'white',
      link: '/blog/case-study-tojjar/',
    },
    id: 'box-Tojjar',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'Virgin Radio Oman',
      industry: ['Media'],
      service: ['Full Cycle Product Development'],
      subtitle: 'I provided minimal direction about expectations. They took full responsibility for assembling the solution.',
      description: 'Neil de Souza, Project Manager, Sabco Media',
    },
    settings: {
      link: '/reviews/virgin-radio-oman/',
    },
    id: 'box-review-virgin',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'sonnenChargerImage',
      clientLogo: 'logoSonnen',
      title: 'IoT software and app for an electric car charger',
      tags: ['Java', 'ReactNative', 'MVP', 'Germany'],
      industry: ['Energy'],
      service: ['Full Cycle Product Development'],
      subtitle: '',
      description:
        'The client approached Boldare for a mobile app for an EV charger, powered by solar energy. The product was created from scratch by Boldare’s cross functional, agile Prototyping and MVP teams.',
    },
    settings: {
      tileColor: 'rhino',
      textColor: 'white',
    },
    id: 'box-sonnen-charger',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'eresImage',
      clientLogo: 'logoEres',
      title:
        'How to successfully transition from a physical business to digital service.',
      tags: ['workshops', 'webdesign', 'consulting'],
      industry: ['Travel'],
      service: ['Digital Transformation', 'Product Design and Development'],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'rodeo-dust',
      textColor: 'white',
      link: '/blog/case-study-eres-yachting-booking-platform/',
    },
    id: 'box-eres',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'Brass Willow',
      industry: ['B2B Services'],
      service: ['Full Cycle Product Development'],
      subtitle: 'Their productivity, compared to other companies we’ve used as consultants, is about 50% higher.',
      description: 'Michal Fopp, Product Owner, Brass Willow',
    },
    settings: {
      link: '/reviews/brasswillow/',
    },
    id: 'box-review-brasswillow',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'ionoImage',
      clientLogo: 'logoIono',
      title:
        'How to scale a monolithic MVP application without losing business?',
      tags: ['php', 'symfony', 'agile', 'microservices', 'consulting'],
      industry: ['SaaS'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'gray-darker',
      textColor: 'white',
      link: '/blog/case-study-ionoview/',
    },
    id: 'box-Iono',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '4.5',
      title: 'Holiday Taxis',
      industry: ['Travel'],
      service: ['Product Design and Development'],
      subtitle: 'Boldare can easily complement your own team, increase productivity, and improve missing skill sets. We really enjoyed working with them.',
      description: 'Head of IT, Holiday Taxis',
    },
    settings: {
      link: '/reviews/holiday-taxis/',
    },
    id: 'box-review-taxi',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'psoImage',
      clientLogo: 'logoPSO',
      title:
        'How to speed up content moderation for e-commerce with machine learning',
      tags: ['php', 'automation', 'AWS', 'Symfony2', 'ML'],
      industry: ['E-commerce'],
      service: ['Machine Learning'],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'yellow-dark',
      link: '/blog/machine-learning-content-moderation/',
    },
    id: 'box-PSO',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'bldrImage',
      clientLogo: logoBldr,
      title: 'How to test a business idea using lean startup approach.',
      tags: ['Lean Startup', 'MVP', 'ReactJS'],
      industry: ['IT Services'],
      service: [
        'Full Cycle Product Development',
        'Development Teams',
        'Product Design and Development',
      ],
      subtitle: '',
      description: '',
    },
    settings: {
      tileColor: 'gray-lighter',
      link: '/work/case-study-boldare/',
    },
    id: 'box-Bldr',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'practiTestImage',
      clientLogo: 'logoPractiTest',
      title: 'Product website for a test management SaaS',
      tags: ['HTML5', 'CSS3', 'UX/UI', 'Israel'],
      industry: ['SaaS'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'This startup came to Boldare looking for a product website for a SaaS test management tool that converts data to QA intelligence.Our team created an intuitive human-centered experience for a demanding target persona: QA Engineers.',
    },
    settings: {
      tileColor: 'cello',
      textColor: 'white',
    },
    id: 'box-practi-test',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'Numera Lighting',
      industry: ['E-commerce'],
      service: ['Development Teams'],
      subtitle: 'They demonstrated a true desire to understand and support our business objectives, and this translated into the quality of work they produced.',
      description: 'Marketing Manager',
    },
    settings: {
      link: '/reviews/numera-lighting/',
    },
    id: 'box-review-numera',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'vinersImage',
      clientLogo: 'logoViners',
      title: 'A complex e-commerce for cutlery brand',
      tags: ['Symfony', 'JavaScript', 'Scaling', 'UnitedKingdom'],
      industry: ['E-commerce'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'Viners needed to shift their sales process to digital, requiring a complex e-commerce site for their cutlery brand. We created an e-commerce process that was seamlessly integrated with the client’s warehouse and CRM to maximise customer satisfaction and improve business performance.',
    },
    settings: {
      tileColor: 'dove-gray',
      textColor: 'white',
    },
    id: 'box-viners',
  },
  // {
  //   type: BOX_TYPES.CASE_STUDY,
  //   content: {
  //     coverImage: unifonicImage,
  //     clientLogo: logoUnifonic,
  //     title: 'Unifonic',
  //     tags: [],
  //     industry: ['IT Services'],
  //     service: [
  //       'Full Cycle Product Development',
  //       'Development Teams',
  //       'Product Design and Development',
  //     ],
  //     subtitle: 'Product-market fit for a SMS solution',
  //     description: 'TO-DO',
  //   },
  //   settings: {
  //     tileColor: 'jungle-green',
  //     textColor: 'white',
  //   },
  //   id: 'box-unifonic',
  // },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'brassWillowImage',
      clientLogo: 'logoBrassWillow',
      title: 'Booking platform for an agile consultancy',
      tags: ['Symfony', 'JavaScript', 'MVP', 'Poland'],
      industry: ['B2B Services'],
      service: ['Full Cycle Product Development'],
      subtitle: '',
      description:
        'The requirement was for a booking platform for an agile consultancy aiming to improve their online sales conversion. Our team created a web app that allows users to select training, sign up, and pay, generating invoices and automating post-purchase communication.',
    },
    settings: {
      tileColor: 'twine',
      textColor: 'white',
    },
    id: 'box-brass-willow',
  },
  {
    type: BOX_TYPES.REVIEW,
    content: {
      rating: '5.0',
      title: 'Lamden',
      industry: ['IT Services'],
      service: ['Development Teams'],
      subtitle: 'They put a lot of thought and strategy into their process. The discovery and brainstorming sessions were very helpful.',
      description: 'Stuart Farmer, CEO, Lamden',
    },
    settings: {
      link: '/reviews/lamden/',
    },
    id: 'box-review-lamden',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'inCampagnaImage',
      clientLogo: 'logoInCampagna',
      title: 'E-commerce for organic food distributor',
      tags: ['Symfony', 'JavaScript', 'UX/UI', 'Italy'],
      industry: ['E-commerce'],
      service: ['Digital Transformation', 'Development Teams'],
      subtitle: '',
      description:
        'An organic food distributor needed to switch to e-commerce as part of their digital transformation.We created an e-commerce platform that aggregates farmers and their products, and also handles administration, warehousing, shipping and sales.',
    },
    settings: {
      tileColor: 'gamboge',
      textColor: 'white',
    },
    id: 'box-incampagna',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'holaSpiritImage',
      clientLogo: 'logoHolaSpirit',
      title: 'Scaling a HR management SaaS',
      tags: ['ReactJS', 'Redux', 'Scaling', 'France'],
      industry: ['SaaS'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'The client came to Boldare for help with stabilizing and scaling their core product, a SaaS HR management tool. Our team helped to shift their product up to the next gear by upgrading the technology, improving on the UX.',
    },
    settings: {
      tileColor: 'mystic',
      textColor: 'black',
    },
    id: 'box-holaspirit',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'apasmartImage',
      clientLogo: 'logoApasmart',
      title: 'Product website for an interior design service',
      tags: ['JavaScript', 'HTML5', 'UX/UI', 'Poland'],
      industry: ['SaaS'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'An interior design service needed a sales platform with a high conversion rate for their building management system. The Boldare  team created a flexible website to help them respond to their changing business needs.',
    },
    settings: {
      tileColor: 'leather',
      textColor: 'white',
    },
    id: 'box-apasmart',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'a2lImage',
      clientLogo: 'logoTakamol',
      title: 'Data visualisation platform',
      tags: ['Symfony', 'JavaScript', 'MVP', 'SaudiArabia'],
      industry: ['B2B Services'],
      service: ['Full Cycle Product Development'],
      subtitle: '',
      description:
        'This government-owned company approached Boldare to build a complex web app, visualizing economic and geographic data for entrepreneurs operating in the region. We provided a cross-functional team who helped to ideate, build and grow a successful product.',
    },
    settings: {
      tileColor: 'turquoise',
      textColor: 'black',
    },
    id: 'box-a2l',
  },
  // {
  //   type: BOX_TYPES.CASE_STUDY,
  //   content: {
  //     coverImage: a2lGeoImage,
  //     clientLogo: logoTakamol,
  //     title: 'A2l Geo',
  //     tags: [],
  //     industry: ['IT Services'],
  //     service: ['Product Design and Development'],
  //     subtitle: 'to-do',
  //     description: 'to-do',
  //   },
  //   settings: {
  //     tileColor: 'turquoise',
  //     textColor: 'black',
  //   },
  //   id: 'box-a2l-geo',
  // },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'planetEscapeImage',
      clientLogo: 'logoPlanetEscape',
      title: 'A booking platform for a premium travel agency',
      tags: ['JavaScript', 'Symfony', 'UX/UI', 'Poland'],
      industry: ['Travel'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'A high-end, bespoke travel agency needed to digitize their customer experience. Boldare’s team created a visually gripping website with a seamless booking process to meet the specific needs of the agency’s premium clients. ',
    },
    settings: {
      tileColor: 'alabaster',
      textColor: 'black',
    },
    id: 'box-planet-escape',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'showbizImage',
      clientLogo: 'logoShowbiz',
      title: 'Online catalogue for a modeling agency',
      tags: ['Symfony', 'JavaScript', 'MVP', 'Italy'],
      industry: ['B2B Services'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'Showbiz needed a complete online experience and catalog for their modeling agency.Boldare combined beautiful design with an easy-to-use search tool with a multitude of filters, and a seamless booking experience.',
    },
    settings: {
      tileColor: 'totem-pole',
      textColor: 'white',
    },
    id: 'box-showbiz-models',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'coleMasonImage',
      clientLogo: 'logoColeMason',
      title: 'Engaging blog for a heritage brand',
      tags: ['JavaScript', 'HTML5', 'UX/UI', 'UnitedKingdom'],
      industry: ['E-commerce'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'This British client turned to us to create Seasoning School, an online recipe guide full of mouth-watering visuals. Boldare created a responsive website that smoothly leads the user from product browsing to conversion.',
    },
    settings: {
      tileColor: 'alabaster',
      textColor: 'black',
    },
    id: 'box-cole-mason',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'paktImage',
      clientLogo: 'logoPakt',
      title: 'Virtual Wardrobe App',
      tags: ['JavaScript', 'CakePHP', 'UX/UI', 'HongKong'],
      industry: ['IT Services'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'This established brand came to Boldare with an idea for an interactive product to help customers find their perfect dinnerware. Our team created a single page virtual tabletop application, with easy filtering and a deluxe interface.',
    },
    settings: {
      tileColor: 'roof-terracotta',
      textColor: 'white',
    },
    id: 'box-pakt',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'oneidaImage',
      clientLogo: 'logoOneida',
      title: 'Virtual Tabletop for a dinnerware brand',
      tags: ['AngularJS', 'PHP', 'UX/UI', 'USA'],
      industry: ['E-commerce'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'The client came to Boldare with an idea for an interactive product helping customers find fitting dinnerware. Our team created a single page application with easy filtering and deluxe interface.',
    },
    settings: {
      tileColor: 'mine-shaft',
      textColor: 'white',
    },
    id: 'box-oneida',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'spaMonkeysImage',
      clientLogo: 'logoSpaMonkeys',
      title: 'E-commerce for a beauty platform',
      tags: ['JavaScript', 'Angular', 'MVP', 'HongKong'],
      industry: ['E-commerce', 'Health & Beauty'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'The client turned to Boldare to build an online shop, locations catalogue and blog for the spa, beauty and wellness industry in Hong Kong. Our role included the creation and phased implementation of a series of comprehensive solutions.',
    },
    settings: {
      tileColor: 'skeptic',
      textColor: 'black',
    },
    id: 'box-spa-monkeys',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'heartpaceImage',
      clientLogo: 'logoHeartpace',
      title: 'Website for a performance review tool',
      tags: ['KeystoneJS', 'HTML5', 'UX/UI', 'Sweden'],
      industry: ['SaaS'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'A Swedish startup turned to Boldare to help them re-launch their product website. Our team  worked on a new UX, UI and overall development to create a truly human-centered online experience.',
    },
    settings: {
      tileColor: 'alabaster',
      textColor: 'black',
    },
    id: 'box-heartpace',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'numeraLightingImage',
      clientLogo: 'logoNumeraLighting',
      title: 'E-commerce for a premium lamp designe',
      tags: ['JavaScript', 'Shopify', 'UX/UI', 'USA'],
      industry: ['E-commerce'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'This American business approached Boldare to create an interactive, online catalog. Using Shopify, we were able to swiftly create a high-performing, modern catalog of the client’s luxury products.',
    },
    settings: {
      tileColor: 'scarpa-flow',
      textColor: 'white',
    },
    id: 'box-numera-lighting',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'rehalatiImage',
      clientLogo: 'logoRehalati',
      title: 'A booking platform for Saudi travellers',
      tags: ['React', 'Redux', 'MVP', 'UAE'],
      industry: ['Travel'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'The client turned to us to create a useful, modern and intuitive booking engine as a response to current needs. In response, Boldare combined human-centered design with the latest front-end technology, React.JS.',
    },
    settings: {
      tileColor: 'pomegranate',
      textColor: 'white',
    },
    id: 'box-rehalati',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'lrBeautyImage',
      clientLogo: 'logoLrBeauty',
      title: 'Online experience for a cosmetics giant',
      tags: ['Symfony', 'React', 'UX/UI', 'Germany'],
      industry: ['Health & Beauty'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'The client approached Boldare to build a new complex website that would drive their new business goals. Employing 3D graphics, Boldare designed an immersive online experience with the aim of drawing in the target audience and converting them into sales reps.',
    },
    settings: {
      tileColor: 'alabaster',
      textColor: 'black',
    },
    id: 'box-lr-beauty',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'ezycountImage',
      clientLogo: 'logoEzycount',
      title: 'Online accounting application for SMBs',
      tags: ['Symfony', 'UX/UI', 'Scaling', 'Switzerland'],
      industry: ['SaaS'],
      service: ['Full Cycle Product Development'],
      subtitle: '',
      description:
        'This Swiss B2B web accounting startup turned to Boldare to build a scalable web application for their accounting software. Our team stabilized the app and built new features,  training the client’s in-house team so they were able to manage the product in future without external assistance.',
    },
    settings: {
      tileColor: 'web-orange',
      textColor: 'black',
    },
    id: 'box-ezycount',
  },
  // {
  //   type: BOX_TYPES.CASE_STUDY,
  //   content: {
  //     coverImage: ezycountImage, // Img to change
  //     clientLogo: logoEzycount, // Img to change
  //     title: 'CRYO',
  //     tags: ['JavaScript', 'Node.JS', 'MVP', 'UAE'],
  //     industry: ['Health & Beauty'],
  //     service: ['Development Teams'],
  //     subtitle: 'Web booking platform for cryotherapy',
  //     description:
  //       'The client approached us with an idea for an online booking system for cryotherapy enthusiasts and service providers. Our team built an app with a catalogue of services, review and rating system, and a booking mechanism for a five star experience.',
  //   },
  //   settings: {
  //     tileColor: 'web-orange', // tmp color
  //     textColor: 'black', // tmp color
  //   },
  //   id: 'box-cryo',
  // },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'digproImage',
      clientLogo: 'logoDigpro',
      title: 'Product website for a SaaS grid management tool',
      tags: ['ReactJS', 'UX/UI', 'MVP', 'Sweden'],
      industry: ['Energy', 'SaaS'],
      service: ['Development Teams'],
      subtitle: '',
      description:
        'dpPower approached Boldare to create a high-converting sales website for their complex SaaS product. Boldare created an integrated enterprise software solution for the complete network lifecycle management of electrical networks.',
    },
    settings: {
      tileColor: 'golden-grass',
      textColor: 'black',
    },
    id: 'box-cryo',
  },
  {
    type: BOX_TYPES.CASE_STUDY,
    content: {
      coverImage: 'chilidTealspaceImage',
      clientLogo: logoChilidTealspace,
      title: 'Showcase landing page',
      tags: ['JavaScript', 'HTML5', 'UX/UI', 'Poland'],
      industry: ['IT Services'],
      service: ['Product Design and Development'],
      subtitle: '',
      description:
        'At Boldare, we wanted to showcase our Teal-based office design. We created an award-winning landing page to present the complex ideas behind our workspace. Using state-of-the-art technology, we created light and isometric illustrations for enhanced visual clarity. ',
    },
    settings: {
      tileColor: 'cold-purple',
      textColor: 'white',
    },
    id: 'box-chilid-tealspace',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Introducing Data Visualization in D3 JavaScript library',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Product Design and Development'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-data-visualisation-JS',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Marble.js – new open source framework for JavaScript',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Product Design and Development'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-marblejs',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Digitalizing renewable energy',
    content: {
      industry: ['Energy'],
      service: ['Digital Transformation', 'Machine Learning'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-renewable-energy',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'System Story – the little sentence that builds big things',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-system-story',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Lean process for a better product',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Full Cycle Product Development'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-lean-process',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'A step by step guide to Event Storming – our experience',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-event-storming',
  },
  {
    type: BOX_TYPES.BLOG,
    title:
      'Building digital products based on machine learning - the cost perspective',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Machine Learning'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-building-products-ML',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'What are design sprints?',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-design-sprints',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'How machine learning is boosting businesses',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Machine Learning'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-ML-boosting-business',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Scaling Your Product – thriving in the market',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-scaling-product',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Wondering about viability? Let impact mapping reassure you',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-impact-mapping',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'Best Outsourcing Practices Meetup – designed for CTOs',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Product Design and Development'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-outsourcing-practices-meetup',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'How to start a neural network with JavaScript in 5 minutes',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Machine Learning'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-neural-network-JS',
  },
  {
    type: BOX_TYPES.BLOG,
    title:
      'This is how Boldare Development Teams process addresses your business needs',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
        'Digital Transformation',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-digital-products-Bldr',
  },
  {
    type: BOX_TYPES.BLOG,
    title: '6 benefits from having a QA/BA in your development team',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: ['Product Design and Development', 'Development Teams'],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-benefits-qa-ba',
  },
  {
    type: BOX_TYPES.BLOG,
    title: 'MVP development - what, why & how',
    content: {
      industry: [
        'Energy',
        'Media',
        'E-commerce',
        'Travel',
        'SaaS',
        'IT Services',
      ],
      service: [
        'Product Design and Development',
        'Full Cycle Product Development',
        'Development Teams',
      ],
    },
    settings: {
      tileColor: 'gray-lighter',
    },
    id: 'box-what-why-how-MVP',
  },
];
